var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8939 14.4798L1.36603 0.943959C1.05403 0.631962 0.550033 0.631962 0.238036 0.943959C-0.0739608 1.25596 -0.0819607 1.75995 0.230036 2.07195L3.782 5.62391V15.1998C3.782 15.6398 4.142 15.9998 4.58199 15.9998H10.9819C11.4219 15.9998 11.7819 15.6398 11.7819 15.1998V13.6238L13.7659 15.6078C13.9259 15.7678 14.1259 15.8398 14.3339 15.8398C14.5419 15.8398 14.7419 15.7598 14.9019 15.6078C15.2139 15.2958 15.2139 14.7918 14.9019 14.4798H14.8939ZM10.1819 12.7998H5.38199V7.2239L10.1819 12.0239V12.7998Z",
    fill: "#AA0004"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1819 3.19997V7.49593L11.7819 9.09591V2.39998C11.7819 1.95998 11.4219 1.59998 10.9819 1.59998H9.38193V0.799992C9.38193 0.359996 9.02194 0 8.58194 0H6.98196C6.54196 0 6.18197 0.359996 6.18197 0.799992V1.59998H4.58198C4.49398 1.59998 4.41398 1.62398 4.33398 1.64798L5.88597 3.19997H10.1819Z",
    fill: "#AA0004"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryLow);
export default __webpack_public_path__ + "static/media/BatteryLow.97ed0c1d6df15fc969920fa6f37e5814.svg";
export { ForwardRef as ReactComponent };